import { Injectable } from "@angular/core";
import { HttpService } from "src/app/services/http.service";
import { ResourceAccess, Resource, AdminAccess, DeleteResourceReponse, GetResourcesResponse, ResetAdminPasswordResponse } from "./resource-access.models";
import { environment } from "src/environments/environment";
import { Employee } from "../customer/customer.model";
import { MainStore } from "src/app/common/main.store";
import { CommonService } from "src/app/services/common.service";

@Injectable()
export class ResourceAccessService {
    constructor(
        private http: HttpService,
        private store: MainStore,
        private commonService: CommonService
    ) { }



    async getExternalResources(departmentId: string): Promise<Resource[]> {
        let response = await this.http.get<Resource[]>(`${environment.adminConfig.apiUri}/resourceAccess/external/consultants/${departmentId}`);
        for (let resource of response) {
            //setting up frontend data
            resource.customers = [];
            resource.showCustomers = false;
            resource.loadingCustomers = false;
        }
        return response;
    }

    async getExternalResourceAccesses(guid: string): Promise<ResourceAccess[]> {
        return await this.http.get<ResourceAccess[]>(`${environment.adminConfig.apiUri}/resourceAccess/external/${guid}`);
    }



    async getAdminDepartments(): Promise<any> {
        return await this.http.get<any>(`${environment.adminConfig.apiUri}/resourceAccess/adminDepartments`);
    }

    async getAdminResources(departmentId: string): Promise<AdminAccess[]> {
        return await this.http.get<AdminAccess[]>(`${environment.adminConfig.apiUri}/resourceAccess/adminResource/${departmentId}`);
    }

    async getAllAdminResources(): Promise<AdminAccess[]> {
        return await this.http.get<AdminAccess[]>(`${environment.adminConfig.apiUri}/resourceAccess/adminResource/all`);
    }

    async postAdminResource(resourceGuid: string): Promise<AdminAccess[]> {
        return await this.http.post<AdminAccess[], any>(`${environment.adminConfig.apiUri}/resourceAccess/adminResource/${resourceGuid}`, null);
    }

    async deleteAdminResource(adminResourceGuid: string): Promise<DeleteResourceReponse> {
        return await this.http.delete<DeleteResourceReponse>(`${environment.adminConfig.apiUri}/resourceAccess/adminResource/${adminResourceGuid}`);
    }

    async resetAdminPassword(adminResourceGuid: string): Promise<ResetAdminPasswordResponse> {
        return await this.http.put<ResetAdminPasswordResponse, any>(`${environment.adminConfig.apiUri}/resourceAccess/adminResource/${adminResourceGuid}/reset`, null);
    }

    async getDepartmentResources(departmentId: string): Promise<GetResourcesResponse[]> {
        return await this.http.get<GetResourcesResponse[]>(`${environment.adminConfig.apiUri}/resourceAccess/resources/${departmentId}`);
    }
    
    async getEmployees(departmentcode: string): Promise<Employee[]> {
        return await this.http.get<Employee[]>(`${environment.adminConfig.apiUri}/resourceAccess/employees/${departmentcode}`);
    }

    async AddUser(choosenEmployeeId: string): Promise<boolean> {       
        const data = { employeeId: choosenEmployeeId,  departmentId: this.store.selectedDepartment.get()?.id ?? this.commonService.guidEmpty() };   
        return await this.http.put<boolean, any>(`${environment.adminConfig.apiUri}/resourceAccess/employee`, data);
      }

    async RemoveUser(choosenEmployeeId: string): Promise<boolean> {       
        const data = { employeeId: choosenEmployeeId,  departmentId: this.store.selectedDepartment.get()?.id ?? this.commonService.guidEmpty() };   
        return await this.http.post<boolean,any>(`${environment.adminConfig.apiUri}/resourceAccess/removeemployee`, data);
      }
}